var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"properties"},[_c('property',{attrs:{"name":"סוג מנוי","value":"פעיל"}}),_vm._v(" "),_c('property',{attrs:{"name":"תאריך חיוב הבא","value":_vm.nextPaymentDateDisplayValue}})],1),_vm._v(" "),_c('separator'),_vm._v(" "),_c('update-credit-card-button')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37f1eb72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/account-settings/SubscribedSettings.vue
// module id = null
// module chunks = 